require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// /Users/akshetpandey/workspace/thriller-server/~/core-js/library/fn/is-iterable.js
// module id = 639
// module chunks = 168707334958949